import LandingPage from 'pages/landingPage';
import OAuthCallback from 'pages/OAuthCallback';
import GetStarted from 'pages/landingPage/GetStarted';
import SignupVerification from 'pages/SignupVerification';
import Login from 'pages/Login';
import LoginVerification from 'pages/LoginVerification';
import Register from 'pages/Register';
import ChooseCategory from 'pages/ChooseCategory';
import Deals from 'pages/Deals';
import PreOffers from 'pages/PreOffers';
import Action from 'pages/Action';
import Training from 'pages/Training';
import UploadComPlete from 'pages/UploadComPlete';
import Delivery from 'pages/Delivery';
import TransHistory from 'pages/TransHistory';
import StoreFront from 'pages/StoreFront';
import ForgotPassword from 'pages/ForgotPassword';
import ResetPassword from 'pages/ResetPassword';
import StorePage from 'pages/store';
import StoreCart from 'pages/store/StoreCart';

const landingPageRoutes = [
    { path: '/', element: <LandingPage /> },
    { path: '/get-started', element: <GetStarted /> },
    { path: '/login', element: <Login /> },
    { path: '/forgot-password', element: <ForgotPassword /> },
    { path: '/reset-password', element: <ResetPassword /> },
    { path: '/register', element: <Register /> },
    { path: '/login-verify', element: <LoginVerification /> },
    { path: '/choose-category', element: <ChooseCategory /> },
    { path: '/signup-verify', element: <SignupVerification /> },
    { path: '/pre-offers', element: <PreOffers /> },
    { path: '/actions', element: <Action /> },
    { path: '/training', element: <Training /> },
    { path: '/complete-training', element: <UploadComPlete /> },
    { path: '/delivery/:id', element: <Delivery /> },
    { path: '/invoice/:id', element: <TransHistory /> },
    { path: '/deals', element: <Deals /> },
    { path: '/storeFront', element: <StoreFront /> },
    { path: '/store/:storeName', element: <StorePage /> },
    { path: '/store/:storeName/cart', element: <StoreCart /> },
    { path: '/oauth-callback', element: <OAuthCallback /> },
];

export { landingPageRoutes };
